import { useCallback, useEffect, useState } from "react";

const useInfiniteScroll = ({

    enabled = true,

    loading = false,

    hasMore = true,

    onLoadMore,

    root = null,

    rootMargin = "150px",

    threshold = 0,

}) => {

    const [node, setNode] = useState(null);

    const ref = useCallback((element) => {

        setNode(element);

    }, []);

    useEffect(() => {

        if (

            !enabled ||

            loading ||

            !hasMore ||

            !node

        ) {

            return;

        }

        const observer = new IntersectionObserver(

            (entries) => {

                if (entries[0].isIntersecting) {

                    onLoadMore?.();

                }

            },

            {

                root,

                rootMargin,

                threshold,

            }

        );

        observer.observe(node);

        return () => observer.disconnect();

    }, [

        node,

        enabled,

        loading,

        hasMore,

        onLoadMore,

        root,

        rootMargin,

        threshold,

    ]);

    return ref;

};

export default useInfiniteScroll;